import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import {
  Button,
  PageTitle,
  PseudoStates,
} from '@cordata/buffet';
import {
  Modal,
  ModalHeader,
  ModalFooter,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { adminInstance as axiosAdmin } from '~/utils';

import Form from '~/components/DivisionLogo/Form';

const DivisionLogosDetails = () => {
  const params = useParams();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState();
  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = useState(false);

  useEffect(() => {
    axiosAdmin
      .get(`/division-logo/${params.division_logo_id}`)
      .then(r => r.data.data)
      .then(r => setData(r))
      .catch(e => setError(e))
      .then(() => setIsLoading(false));
  }, []);

  const deleteLogo = () =>
    axiosAdmin
      .delete(`/division-logo/${params.division_logo_id}`)
      .then(() => history.push('/organization/division-logos'));

  return !isLoading && !error
    ? (<>
      <PageTitle
        action={
          <Button color="danger" inverse outline onClick={() => setIsConfirmDeleteModalOpen(true)}>
            <FontAwesomeIcon icon="trash" className="mr-2" />
            Delete
          </Button>
        }
      >
        Edit Logo
      </PageTitle>

      <Form data={data} />

      <Modal isOpen={isConfirmDeleteModalOpen} backdrop="static" size="lg">
        <ModalHeader>Are you sure you want to delete this?</ModalHeader>

        <ModalFooter>
          <Button type="cancel" onClick={() => setIsConfirmDeleteModalOpen(false)}>Cancel</Button>
          <Button color="danger" onClick={() => deleteLogo()}>
            <FontAwesomeIcon icon="trash" className="mr-2" />
            Yes, delete it
          </Button>
        </ModalFooter>
      </Modal>
    </>)
    : (<PseudoStates isLoading={isLoading} error={error} />);
};

export default DivisionLogosDetails;
